import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import { useLoginContext } from "../../Contexts/LoginContext";
import { useOrderTypeContext } from "../../Contexts/OrderTypeContext";
import CustomerService from "../../Services/CustomerService";
import { ImSpinner8 } from "react-icons/im";
import { TbMoodConfuzed } from "react-icons/tb";
import ProfileTitle from "./ProfileTitle";
import { useTranslation } from "react-i18next";
import SlotAddressChoice from "../../Components/Layout/SlotAddressChoice";

const ProfileAddresses = () => {
    
    const { t } = useTranslation();
    const pageTitle = t('profile.addresses.title');
    document.title = pageTitle;

    const { currentStore } = useStoreContext();
    const { orderType } = useOrderTypeContext();
    const { isAuthenticated } = useLoginContext();
    const [ loadingSearchCustomerAddresses, setLoadingSearchCustomerAddresses ] = useState(false);
    const [ customerAddressesList, setCustomerAddressesList ] = useState<any[]>([]);

    const getCustomerAddresses = async (enableLoading: boolean = true) => {

        if (!isAuthenticated || orderType === null) return;

        try {
            setLoadingSearchCustomerAddresses(enableLoading);

            const customerService = new CustomerService(orderType);
            const response = await customerService.getCustomerAddresses();

            if (response) {
                setCustomerAddressesList(response);
            }
        } catch (error: any) {
            setCustomerAddressesList([]);
        } finally {
            setLoadingSearchCustomerAddresses(false);
        };

    }

    useEffect(() => {
        getCustomerAddresses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>
                <div className="flex flex-col gap-2 p-2 pt-0">

                    <ProfileTitle>{ pageTitle }</ProfileTitle>

                    {loadingSearchCustomerAddresses && (
                        <div className="flex items-center gap-1 text-gray-500"><ImSpinner8 className="animate-spin" /><span>{t('layout.loading')}</span></div>
                    )}

                    {!loadingSearchCustomerAddresses && (
                        Array.isArray(customerAddressesList) && customerAddressesList.length > 0
                            ?   <div className="grid h-full gap-4 md:grid-cols-2 xl:grid-cols-3">
                                    {customerAddressesList.map((address: any) => (
                                        <SlotAddressChoice hasDelete outline key={address.id} address={address} onDelete={() => getCustomerAddresses(false)} />
                                    ))}
                                </div>
                            : <div className="flex items-center gap-1 text-gray-500"><TbMoodConfuzed /><span>{t('profile.addresses.no_address_found')}</span></div>
                    )}
                </div>
            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileAddresses;